import React from "react";
import MasterComponent from "../../../../components/Forms";
import { RoleTitleConfig } from "../../../../entity/Organisations/Employees/Settings/RoleTitle";

const Roles = () => {


    return (
        <MasterComponent config={RoleTitleConfig} />
    );
}

export default Roles;